import React from "react";
import * as R from "ramda";
import classNames from "classnames";
import style from "../styles.scss";
import { withProps } from "utils/General";
import { MediumOutlineButton, OpenInNewIcon } from "components/Base";
import { getters, actions } from "../../../model";
// import { TASK_TYPES } from "../../../constants";
import { connect } from "react-redux";

const decorate = connect(
  state => ({
    taskData: getters.taskData(state)
  }),
  {
    executeAction: actions.executeAction
  }
);

const CustomTask = ({
  // completionMethod,
  description,
  url
  // executeAction,
  // taskData
}) => {
  return (
    <div className={style.innerContainer}>
      <div className={style.description}>
        <div
          className={classNames(style.textRegular, style.descriptionText)}
          dangerouslySetInnerHTML={{
            __html:
              R.isEmpty(description) || R.isNil(description) ? "-" : description
          }}
        ></div>
      </div>
      {url && url.length ? (
        <MediumOutlineButton
          bg="white"
          color="neutral7"
          bc="neutral2"
          onClick={() => {
            window.open(url, "_blank");

            // @NOTE: Disabling this because we don't support "click" completion method in new portals currently
            // if completion status is "on click", then fire off task completion if task has yet to be completed
            // if (
            //   completionMethod &&
            //   completionMethod === "click" &&
            //   taskData.status !== "complete"
            // ) {
            //   executeAction({ type: TASK_TYPES.TOGGLE_TASK, data: taskData });
            // }
          }}
          RightIcon={withProps({ size: "14" })(OpenInNewIcon)}
          style={{
            borderWidth: "1px",
            height: "38px",
            width: "107px",
            fontSize: "14px"
          }}
        >
          Open Link
        </MediumOutlineButton>
      ) : null}
    </div>
  );
};

export default decorate(CustomTask);
